
namespace RioERP.Orders {
    export class WebsiteOrderProductsColumns {
        static columnsKey = 'Orders.WebsiteOrderProducts';
    }
}